import { Box } from '@mui/material';
import Body from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/Body';
import { DatePicker } from '@cmhc-schl/hearth-ui';
import React from 'react';
import { TextFormFieldProps } from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/form/TextFormField';

export interface DatePickerFormFieldProps extends TextFormFieldProps {
  label: string;
  isReadOnly: boolean;
  value: string | undefined;
  error: boolean;
  errorMessage?: string;
  dateFormat: string;
  onValueChange?: (value: Date | null) => void;
}

const parseLocalDate = (dateString: string | undefined) => {
  if (!dateString) return undefined;
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const DatePickerFormField = ({ ...props }: DatePickerFormFieldProps) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="8px"
      flexGrow="1"
      sx={{
        '.datePickerFormField .MuiInputBase-root.Mui-focused': {
          textDecorationColor: 'var(--digital-blue, #1e2d73) !important',
          outline: '1px solid var(--white, #fff)',
          borderRadius: 'initial',
          background: 'var(--white, #fff)',
          border: '2px solid #1976D2',
          outlineOffset: '1px'
        },
        '.datePickerFormField :active': {
          outline: '1px solid transparent'
        }
      }}
    >
      <Body size={'smallBold'}>{props.label}</Body>
      <DatePicker
        disabled={props.isReadOnly}
        error={props.error}
        errorMessage={props.errorMessage}
        value={parseLocalDate(props.value)}
        className={'datePickerFormField'}
        format={props.dateFormat}
        onChange={props.onValueChange}
      ></DatePicker>
    </Box>
  );
};
